import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMatingDate = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinejoin: "round",
		strokeMiterlimit: 2
	},
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "heart",
		transform: "matrix(0.541667,0,0,0.541667,11.7646,14.8482)",
		children: /* @__PURE__ */ _jsx("g", {
			transform: "matrix(1,0,0,1,-12,-12)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12,21.35L10.55,20.03C5.4,15.36 2,12.28 2,8.5C2,5.42 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.09C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.42 22,8.5C22,12.28 18.6,15.36 13.45,20.04L12,21.35Z",
				style: { fillRule: "nonzero" }
			})
		})
	}), /* @__PURE__ */ _jsx("g", {
		id: "image-2-.svg",
		transform: "matrix(1,0,0,1,11.5153,12.2981)",
		children: /* @__PURE__ */ _jsx("g", {
			transform: "matrix(1,0,0,1,-12,-12)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20,3L19,3L19,1L17,1L17,3L7,3L7,1L5,1L5,3L4,3C2.9,3 2,3.9 2,5L2,21C2,22.1 2.9,23 4,23L20,23C21.1,23 22,22.1 22,21L22,5C22,3.9 21.1,3 20,3ZM20,21L4,21L4,8L20,8L20,21Z",
				style: { fillRule: "nonzero" }
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgMatingDate);
export { ForwardRef as ReactComponent };
